module.exports = __webpack_public_path__ + "static/media/magnify.d50ba4a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/img/magnify.png
// module id = 147
// module chunks = 0